module.exports = __webpack_public_path__ + "static/media/WebPub-logo.e51e4e20.svg";